import React from 'react'

const PayRoll = () => {
  return (
    <div>
      <p>pay roll</p>
    </div>
  )
}

export default PayRoll
